import React from 'react';
import PropTypes from 'prop-types';

export default function StickyTableWrap({ children, ...rest }) {
    return (
        <div id="sticky-table-wrap" {...rest}>
            {children}
        </div>
    )
}

StickyTableWrap.propTypes = {
    children: PropTypes.node.isRequired
};